// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__GcrT4","fileBtn":"File_fileBtn__8wCWM","closeBtn":"File_closeBtn__3fzCU","fileSelected":"File_fileSelected__19RF8","disabled":"File_disabled__3S7fl"};